// Third Party
import { createUserManager } from "redux-oidc";

// Project
import aadb2cConfig from "./config/aadb2cConfig";

const userManager = createUserManager(aadb2cConfig);

export default userManager;
